
const digest = 'af9a3cae50bc353b40d2287d5354d2b7b21d75c4619f4354e08841224b99e010';
const classes = {"topContent":"_topContent_755oy_1","required":"_required_755oy_7"};
const css = `._topContent_755oy_1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

._required_755oy_7 {
  display: inline-block;
  font-size: 10px;
  font-weight: 500;
  color: #909090;
  text-align: right;
  padding-bottom: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  